import { Box } from '@mui/material'
import { Drawer, Loader } from 'packages/eid-ui'
import ItemHeader from '../ItemHeader'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import MailboxDetails from './MailboxDetails'
import { useMailbox } from 'hooks'
import { catalogDetailsDrawerExplainProps } from '../catalogDetailsDrawerExplain'

const MailboxDrawer = ({ id, toggleDrawer, attributes }) => {
    const isSmallScreen = useIsSmallScreen()

    const { data: mailbox } = useMailbox(id)

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <Box {...catalogDetailsDrawerExplainProps('mailbox')}>
                <ItemHeader title={mailbox?.friendlyName} />
                {!mailbox && <Loader />}
                {mailbox && (
                    <MailboxDetails
                        mailbox={mailbox}
                        toggleDrawer={toggleDrawer}
                        attributes={attributes}
                    />
                )}
            </Box>
        </ItemsDetailsMobileWrapper>
    ) : (
        <Drawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            closeOnOutsideClick
            header={<ItemHeader title={mailbox?.friendlyName} />}
        >
            <Box {...catalogDetailsDrawerExplainProps('mailbox')}>
                {!mailbox && <Loader />}
                {mailbox && (
                    <MailboxDetails
                        mailbox={mailbox}
                        toggleDrawer={toggleDrawer}
                    />
                )}
            </Box>
        </Drawer>
    )
}

export default MailboxDrawer
